const default_colors = { 
    0: 'No Sock', 
    1: 'Navy', 
    2: 'Scarlet', 
    3: 'Columbia Blue', 
    4: 'Grey', 
    5: 'Graphite' 
};

const colors = {
    'Air Force Blue': '%23006699', 
    'Black': '%23000000', 
    'Brown': '%2365431f', 
    'Bright Yellow': '%23ffff66',
    'Cardinal': '%23871728',
    'Columbia Blue': '%236699cc',
    'Cream': '%23FCFBE3',
    'Dark Gold': '%23ffcc33',
    'Dark Green': '%23005e35',
    'Dark Navy': '%23001D45',
    'Dark Royal': '%2300519c', 
    'Fuchsia': '%23dc81bb',
    'Gold': '%23FBCB13', 
    'Graphite': '%23454343', 
    'Grey': '%23b4b5b9',
    'Hot Pink': '%23ff3eb5',
    'Ivory': '%23fffff0',
    'Lavender': '%238a8ccd',
    'Lime': '%2398DEB3',
    'Marlin Teal': '%2300aabe',
    'Maroon': '%23500000',
    'Navy': '%23041c2c',
    'Neon Green': '%2300FF00',
    'Neon Blue': '%23009cdd',
    'Neon Yellow': '%23fef900',
    'Neon Orange': '%23ff4300',
    'Neon Gold': '%23fef900',
    'Old Gold': '%23A19244',
    'Orange': '%23ff6e00',
    'Pink': '%23ffccd7',
    'Purple': '%2338187f',
    'Royal': '%23005cb0',
    'Scarlet': '%23CE1934',
    'Scarlet Red': '%23CE1934',
    'Sedona Red': '%23a80027',
    'Sky Blue': '%2387CEEB',
    'Royal Blue': '%234169E1',
    'Teal': '%23008587',
    'Tennessee Orange': '%23ff8b00',
    'Texas Orange': '%23d95400',
    'Turquoise': '%2300a0cf',
    'Vegas Gold': '%23d5cc9d',
    'White': '%23FAFAFA',
    'Yellow': '%23fffb7d',
    'Red': '%23a41c27',
    'Blue': '%2332479e',
    'Bubblegum Pink': '%23e27081',
    'Sky': '%23b3d7ff',
    'Kelly Green': '%2300a74a',
    'Kelly': '%2300a74a',
    'Forest': '%23005e35',
    'Silver': '%23b4b5b9',
    'Neon Pink': '%23ff3eb5',
    'Athletic Gold': '%23f6b81e',
    'Vegas': '%23cab155',
    'Olive': '%23394b35',
    'No Sock': '%23ffffff',
};

var customerPhoto;

// ==========================================
// 1. MAIN UPDATE FUNCTION (Cleaned)
// ==========================================
function update_colors() {
    var cc = '';
    if (customerPhoto) {
        cc = 'customerPhoto[https://socksrock.herokuapp.com/' + customerPhoto + '],';
    }
      
    // Color variants fetch
    jQuery('select[name*="properties"]').each(function(index) {
        var i = index + 1;
        if (colors[jQuery(this).val()] !== undefined) {
            cc = cc + 'color' + i.toString() + '[' + colors[jQuery(this).val()] + '],';
        }
    });  

    // Toe text fetch
    var tiotext = ""; 
    const toeText = jQuery('input[name="properties[Toe Text]"]').val();
    if (toeText) {
        tiotext = "line1[" + toeText + "]";
    }

    // Logo upload fetch
    var uploadlogo = "";
    var checkavailable = document.querySelector(".bold_option_uploadfile");
    if (checkavailable) {
        const uploadLogoSrc = jQuery('#img_preview_0').attr('src');
        if (uploadLogoSrc && uploadLogoSrc !== "") {
            uploadlogo = "customerPhoto[" + uploadLogoSrc + "]";
        }
    }

    // Generate Final URL
    const newImageUrl = "https://socks.liquifire.com/socks?set=" + cc + "style[" + product_title + "]" + tiotext + uploadlogo + ",version[web]&call=url[file:foundation/main]&scale=size[500]&sink";

    // FIX BLINK: Sirf tabhi update karein jab URL sach mein change hua ho
    if (document.images.theImageA && document.images.theImageA.src !== newImageUrl) {
        document.images.theImageA.src = newImageUrl;
        $("#product_pic").val(newImageUrl);
    }
}

function set_pic(pic) {
    customerPhoto = pic;
    update_colors();  
}

// ==========================================
// 2. MUTATION OBSERVER (Moved OUTSIDE update_colors)
// ==========================================
jQuery(function() {
    const checkPreviewExist = setInterval(function() {
        const imgPreviewElement = document.querySelector('#img_preview_0');
        
        if (imgPreviewElement) {
            if (!imgPreviewElement.hasAttribute('data-observed')) {
                const observer = new MutationObserver((mutationsList) => {
                    mutationsList.forEach((mutation) => {
                        if (mutation.type === "attributes" && mutation.attributeName === "src") {
                            update_colors(); // Logo change hone par update chalega
                        }
                    });
                });

                observer.observe(imgPreviewElement, { attributes: true, attributeFilter: ['src'] });
                imgPreviewElement.setAttribute('data-observed', 'true');
            }
            clearInterval(checkPreviewExist); // Element milne ke baad loop stop
        }
    }, 1000);
});

// ==========================================
// 3. OTHER HELPER FUNCTIONS
// ==========================================
jQuery(function() {
    var data_min = $('.qty').attr('data-min');
    $('.qty').val(data_min);
    
    $('input#quantity[data-min]').change(function() {
        if (parseInt(this.value) < parseInt($(this).attr('data-min'))) {
            this.value = $(this).attr('data-min');
        }
    });
});

function watch(e) {
    let el = e;
    const intID = setInterval(function() {
        const display = $(el).css('display');
        let checker = $("input[name=sockstyle]").val();  
        checker = (checker != 'liquidfire') ? 'block' : 'none';
      
        $('select[name*="properties"]').each(function(index) {
            if (!$(this).val()) {
                $(this).val($(this).find('option').eq(1).attr('value'));
            }
        });     
        
        // Initial call
        update_colors();

        // FIX: Duplicate event prevention
        $('select[name*="properties"]').off('change').on('change', function() {
            update_colors();
        });
        
        let typingTimer;
        const doneTypingInterval = 300; 
        
        // FIX: Keyup debouncing setup
        $('input[name="properties[Toe Text]"]').off('keyup').on('keyup', function(e) {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(function() {
                update_colors();
            }, doneTypingInterval);
        });

        clearInterval(intID);
      
    }, 1000);
}

// Ensure watch() runs only once
jQuery(function() {
    const $shappifyOptions = $("[id*='shappify_custom_options_']");
    if ($shappifyOptions.length > 0) {
        watch($shappifyOptions.first()); 
    }
});

function watch_exist(e) {
    let el = e;
    const intID = setInterval(function() { 
        if (typeof el === 'string') {
            el = $('#' + el); 
        } else if (el instanceof jQuery) {
            if (el.length > 0) {
                clearInterval(intID);
            }
        }
    }, 100);
}

watch_exist('product-select-option-1');